import { Controller } from "@hotwired/stimulus"

// Native <option hidden> is unreliable in Safari and some Chrome versions.
// Cache all options on connect and rebuild the select on every filter.
export default class extends Controller {
  static targets = ["query", "garmentType", "select"]

  connect() {
    // Snapshot original options (value, label, data attrs) once
    this.allOptions = Array.from(this.selectTarget.options).map((opt) => ({
      value:       opt.value,
      label:       opt.textContent,
      name:        opt.dataset.name || opt.textContent || "",
      garmentType: opt.dataset.garmentType || "",
      isBlank:     !opt.value
    }))
    this.previousValue = this.selectTarget.value
    this.filter()
  }

  filter() {
    const q           = (this.hasQueryTarget ? this.queryTarget.value : "").toLowerCase().trim()
    const garmentType = this.hasGarmentTypeTarget ? this.garmentTypeTarget.value : ""

    const filtered = this.allOptions.filter((o) => {
      if (o.isBlank) return true
      const matchesQuery   = q.length === 0 || o.name.toLowerCase().includes(q)
      const matchesGarment = garmentType.length === 0 || o.garmentType === garmentType
      return matchesQuery && matchesGarment
    })

    // Rebuild options
    const currentValue = this.selectTarget.value
    this.selectTarget.innerHTML = ""
    filtered.forEach((o) => {
      const opt = document.createElement("option")
      opt.value = o.value
      opt.textContent = o.label
      if (o.name)        opt.dataset.name = o.name
      if (o.garmentType) opt.dataset.garmentType = o.garmentType
      this.selectTarget.appendChild(opt)
    })

    // Preserve selection if still valid, else fall back to blank
    if (filtered.some((o) => o.value === currentValue)) {
      this.selectTarget.value = currentValue
    } else {
      this.selectTarget.value = ""
    }
  }
}
